import { formatMessage } from "lib/globalize-util";
import React from "react";

const listOfSpecifications = [
    "XLS, XLSX, or CSV only",
    "Remove any additional columns that are not part of the import.",
    "Doors or attributes not included in your file will remain as-is.",
    "Non-editable columns will be skipped.",
    "Make sure all column names are unique.",
    "Maximum file size: 2MB",
];

export const useFileSpecificationsAndTipsForUpload = () => {
    return {
        title: formatMessage("File specifications & upload tips:"),
        items: listOfSpecifications.map((spec, index) => <li key={`${spec}-${index}`}>{formatMessage(spec)}</li>),
    };
};
